import React, { useState, useEffect } from 'react';
import SliderWrapper from 'jd-library/SliderWrapper';
import historyHandler from 'jd-library/historyHandler';
import { useHistory} from "react-router-dom";
import Container from 'jd-library/Container';
import {connect} from 'react-redux';
import styles from './styles/index.scss';

import FormContainer from './components/formContainer';
import CustomAttributesGenerator from './components/customAttribute';

import { validateAndUpdate } from './customActions';
import {
    resetContentUnitData,
    toggleSpecificationSlider,
    updateSpecificationData,
    updateBrandManufactureDetails,
    updateContentUnitPerPiece,
    resetBrandManufactureData,
    resetSpecificationFormData
} from "../../../actions/productSpecification";

import toastMessageActions from 'jd-library/toastMessageActions';
import FormElement from '../FormElement';

import ContentUnitPerPiece from './components/contentUnitPerPieceContainer';
import { updateEditProductDetail } from '../../../actions/products';
import { Regex, universalClose } from '../../../utills';
import ValidationModal from '../../../common/description-Ai-modals/ValidationModal';

function SpecificationSlider(props) {
    const {
        updateSpecificationData,
        productOrService
    } = props
    const [installData,updateInstallData] = useState({
        ins_days: '',
        ins_amount: '',
        ins_cover: '',
        ins_not_cover: ''
    });

    const [installError, updateInstallErr] = useState({});
    let history = useHistory();
    const [showAIModal,toggleModal] = useState({show: false});

    const sliderOptions = {
        avoidPortal:"true",
        header: {
            heading: "Specifications",
            variant: "secondary",
            rightIcons: props.deviceData.isMobile?  [] : [{
                className: 'icon-HDRcross',
                onClick: () => {
                    universalClose(props.fromSellerDashboard,historyHandler);
                    //historyHandler.closeCurrent();
                }
            }],
            leftIcons: [{
                className: 'icon-HDRback',
                onClick: () => {
                    historyHandler.closeCurrent();
                }
            }]
        },
        onHidden : () => {
            props.toggleSpecificationSlider({specSlider: !props.isSliderOpen});
            props.resetContentUnitData();
            props.resetSpecificationFormData();
        },
        footer: {
            btnProps: props.isReadOnly ? [] : [{
                children: 'Save',
                onClick: onSubmitHandler,
                className: props.hasGlassFooter ? styles['btn'] : ''
            }]
        }
    }

    useEffect(() => {
        let data = {};
        if(props.specification?.length){
            let specs = [...props.specification];
            props.specification.map((cur,index) => {
                if(['ins_days','ins_amount','ins_cover','ins_not_cover'].includes(cur.name)){
                    data[cur.name] = cur.value[0];
                    specs.splice(specs.indexOf(cur.name),1);
                }
            })
            props.updateEditProductDetail([{
                key: 'specification',
                value: specs
            }]);
        }
        if(props.installDetails){
            props.installDetails.map(cur => {
                if(cur.values[0]){
                    data[cur.name] = cur.values[0];
                }
            })
        }
        data && updateInstallData(data);
    },[])

    function onSubmitHandler() {
        let sendData = [...props.installDetails];
        sendData.forEach((cur,index) => {
            cur.values = installData[cur.name]?[installData[cur.name]]:[];
        });
        let bmData = {...props.bmDetails};
        bmData.installData = sendData;
        props.updateBrandManufactureDetails(bmData);

        validateAndUpdate({
            editablePuvSpecAttributes: props.editablePuvSpecAttributes.filter(el => ['country_of_origin']),
            initCustomSpecAttributes : props.initCustomSpecAttributes,
            contentWeightUnit: props.contentWeightUnit,
            productOrService,
            showSellOnline: props.showSellOnline,
            isEnrichSpec: props.isEnrichSpec,
            viaOmni: props.viaOmni,
            isAuditor: props.isAuditor
        }, ({
            initCustomSpecAttributes,
            editablePuvSpecAttributes,
            contentWeightUnit,
            isValidForm,
            error
        }) => {
            if(!isValidForm){
                updateSpecificationData({
                    initCustomSpecAttributes,
                    editablePuvSpecAttributes
                });
                props.updateBrandManufactureDetails({ contentWeightUnit });
                props.toastMessageActions({message: error, type: 'info',bottom: props.hasGlassFooter ? '80px' : '0px',});
                return;
            }

            updateSpecificationData({
                savedPuvSpecAttributes: editablePuvSpecAttributes,
                savedCustomSpecAttributes: initCustomSpecAttributes
            });
            props.updateBrandManufactureDetails({ contentWeightUnitSaved: contentWeightUnit });
            const ignoreField = ['brand', 'country_of_origin', 'price', 'manufacturer', 'manufactured_details', 'importer', 'importers_detail', 'packaging_length', 'packaging_width', 'packaging_height', 'packaging_weight', 'expiry_date'];
            let puvSpecLength =  editablePuvSpecAttributes.filter(cur => !ignoreField.includes(cur.s_nm) && !!cur.userInput.value).length;
            if(props.aiFlow && (puvSpecLength + initCustomSpecAttributes.length) < 5){
                toggleModal({show: true,count: 5 - (puvSpecLength + initCustomSpecAttributes.length)});
                return;
            }else if(props.aiFlow) {
                setTimeout(() => {
                    props.toggleValidationModal({show: true,loadDesc: true,trackClick : true});
                }, 500);
            }
            historyHandler.closeCurrent();
        });
    }

    let handleChange = (value,key) => {
        if(key=="ins_amount"){
            if(!Regex.priceRegex.test(value)){
                return;
            }
            if(value.split(".")[1]?.length>2){
                value=Number(value).toFixed(2)
            }
        }

        if(key=="ins_days"){
            value= value ? (!isNaN(Number(value))?Number(value).toString():"") : '';
        }

        let data = {...installData};
        data[key] = value;
        updateInstallData(data);

    }

    const contentUnitHandleChange = (e, key, data) => {
        const state = JSON.parse(JSON.stringify(props.contentWeightUnit));
        state.contentPerPiece.error = "";
        state.unitPerPiece.error = "";
        const value = key === "unitPerPiece" ? data.displayVal : e.target.value;
        state[key].value = value? value.split(): [];
        props.updateContentUnitPerPiece({contentWeightUnit : state});

    }
    const elementsArr = [{
        label: 'Installation / Demo Days Post Delivery',
        key: 'ins_days',
        holderClass: 'marginT20',
        parentClass: 'installation-div',
        input: {
            type:"text",
            value: installData.ins_days,
            onChange: e => handleChange(e.target.value,'ins_days'),
            onFocus: e => updateInstallErr({...installError,ins_days: ''})
        },
        errorMessage: installError['ins_days'],
        infoMessage: !installError['ins_days'] && props.showSellOnline ?'Required Field':''
    },{
        label: 'Installation / Demo Cost',
        key: 'ins_amount',
        parentClass: 'installation-div',
        holderClass: 'abc',
        input: {
            type:"text",
            value: installData.ins_amount || '',
            onChange: e => handleChange(e.target.value,'ins_amount'),
            onFocus: e => updateInstallErr({...installError,ins_amount: ''})
        },
        errorMessage: installError['ins_amount'],
        infoMessage: !installError['ins_amount'] && props.showSellOnline ?'Required Field':''
    },{
        label: 'Covered under Standard Installation',
        parentClass: 'installation-div',
        key: 'ins_cover',
        input: {
            value: installData.ins_cover,
            onChange: e => handleChange(e.target.value,'ins_cover')
        }
    },{
        label: 'Not Covered under Standard Installation',
        parentClass: 'installation-div',
        key: 'ins_not_cover',
        input: {
            value: installData.ins_not_cover,
            onChange: e => handleChange(e.target.value,'ins_not_cover')
        }
    },{
        customJSX: (
            <div
                className={'marginLR15'}
                style={{
                    borderBottom: '1px solid #ededed',
                    width: 'calc(100% - 30px)'
                }}
            />
        )
    }];

    return (
        <div className={`${styles["product-specification-slider"]} ${props.hasGlassFooter ? styles['ios-cls']: ''}`}>
            <SliderWrapper {...sliderOptions}>
                    <Container className={styles["prod-spec-slider-container"]}>
                        {
                            (props.installationFlag || props.showInstall) &&
                                <FormElement formElements={elementsArr} errors={installError} /> ||
                                null
                        }
                        {showAIModal.show ? <ValidationModal onHidden={() => toggleModal({show: false})} specLessThan5={showAIModal.count} count={showAIModal.count} elementRef={props.inputRef} /> : null}
                        <FormContainer isEnrichSpec={props?.isEnrichSpec}  showSellOnline={props.showSellOnline}/>
                        {(
                            !(
                                props.showInstall ||
                                props.hasCompliance
                            ) ||
                            props?.isEnrichSpec
                        ) ?
                        <>
                            {
                                <CustomAttributesGenerator />
                            }
                            {/*<ContentUnitPerPiece
                                isAddProduct={props.isAddProduct}
                                handleChange={contentUnitHandleChange}
                            />  https://tga.justdial.com/project/sanjaynayal-jd-omni/us/2232?no-milestone=1 */}
                        </>
                        :null}
                    </Container>
            </SliderWrapper>
        </div>
    )
}

const mapStateToProps = (state, props) => {
    return {
        ...props,
        deviceData : state.deviceData,
        isSliderOpen : state.productSpecification.specSliderState,
        aiFlow: state.productSpecification.aiFlow,
        initCustomSpecAttributes: state.productSpecification.initCustomSpecAttributes,
        savedPuvSpecAttributes: state.productSpecification.savedPuvSpecAttributes,
        editablePuvSpecAttributes: state.productSpecification.editablePuvSpecAttributes,
        isEnrichSpec: state.productSpecification?.isEnrichSpec,
        installationFlag: state.productSpecification.installationFlag,
        bmDetails: state.brandManufacturer,
        installDetails: state.brandManufacturer.installData,
        specification: state.products.editProduct && state.products.editProduct.hasOwnProperty('specification')? state.products.editProduct.specification: [],
        contentWeightUnit: state.brandManufacturer.contentWeightUnit,
        hasCompliance: state.products.editProduct.hasCompliance,
        fromSellerDashboard: state.products.fromSellerDashboard,
        viaOmni:state.session.viaOmni,
        isAuditor: state.session?.user?.loggedUser?.userType == "AUDITOR",
        hasGlassFooter: state.session.hasGlassFooter,
        isReadOnly: state.session.isReadOnly
    }
}

const mapDispatchToProps = (dispatch) => ({
    resetContentUnitData: payload => dispatch(resetContentUnitData()),
    updateSpecificationData: payload => dispatch(updateSpecificationData(payload)),
    toggleSpecificationSlider : payload => dispatch(toggleSpecificationSlider(payload)),
    resetSpecificationFormData : payload => dispatch(resetSpecificationFormData(payload)),
    toastMessageActions: payload => dispatch(toastMessageActions.showMessage(payload)),
    updateBrandManufactureDetails: payload => dispatch(updateBrandManufactureDetails(payload)),
    updateContentUnitPerPiece : payload => dispatch(updateContentUnitPerPiece(payload)),
    resetBrandManufactureData: () => dispatch(resetBrandManufactureData()),
    updateEditProductDetail: payload => dispatch(updateEditProductDetail(payload))
})

export default connect(mapStateToProps, mapDispatchToProps)(SpecificationSlider);